// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'avenirBook', 'avenirBook Fallback'","fontWeight":400,"fontStyle":"normal"},"className":"__className_f692dc","variable":"__variable_f692dc"};